"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPhoneInput = exports.StyledDialCodeAddon = void 0;
var _ykbStyledComponents = require("../ykb-styled-components");
var _TextInput = require("../TextInput");
var _Select = _interopRequireDefault(require("../Select"));
var StyledPhoneInput = exports.StyledPhoneInput = (0, _ykbStyledComponents.styled)(_TextInput.TextInput).withConfig({
  componentId: "ykb-ui__sc-6cskbq-0"
})([""]);
var StyledDialCodeAddon = exports.StyledDialCodeAddon = (0, _ykbStyledComponents.styled)(_Select.default).withConfig({
  componentId: "ykb-ui__sc-6cskbq-1"
})(["&.ykb-ui-select-phoneinput{margin:0 -10px;width:", ";.ykb-ui-select-phoneinput-selector{border:none;> div{margin-left:8px;}}}"], function (props) {
  return props.theme.input.phoneInput.dialCodeAddon.width;
});